'use client'

import { toast } from '@/core/lib/toast'

import ChargeSheet from '@/features/veluvit/components/wallet/charge-sheet'
import AttendanceScreen from '@/features/veluvit/components/attendance/attendance-screen'
import HistorySheet from '@/features/veluvit/components/wallet/history-sheet'
import PaywallSheet from '@/features/veluvit/components/wallet/paywall-sheet'
import { api } from '@/features/veluvit/services/api'
import {
  ensureAccount,
  safe,
} from '@/features/veluvit/services/session.service'
import {
  closeAll,
  openModal,
  openSheet,
} from '@/features/veluvit/stores/overlay.store'
import { useSessionStore } from '@/features/veluvit/stores/session.store'
import { useUiStore } from '@/features/veluvit/stores/ui.store'

import type { Bootstrap, Wallet } from '@/features/veluvit/types/api.types'

export function openCharge() {
  closeAll()
  openSheet(<ChargeSheet />, { label: '충전소' })
}

export const openHistory = safe(async () => {
  await ensureAccount()
  const wallet = await api<Wallet>('/wallet/')
  useSessionStore.getState().applyWallet(wallet)
  openSheet(<HistorySheet />, { label: '충전·사용 내역' })
})

export function openAttendance() {
  closeAll()
  openModal(<AttendanceScreen modal />, {
    label: '출석 체크',
    key: 'attendance',
  })
}

/** 페이월 — 두 번까지는 시트, 그다음부터는 토스트 후 충전소 (레퍼런스 pwCount) */
export function openPaywall(need: number) {
  const ui = useUiStore.getState()
  if (ui.pwCount >= 2) {
    toast.show('젬이 부족해요. 충전소에서 상품을 확인해 주세요.')
    openCharge()
    return
  }
  ui.set({ pwCount: ui.pwCount + 1, chatBlurred: true })
  openSheet(<PaywallSheet need={need} />, {
    label: '젬 부족',
    onClose: () => useUiStore.getState().set({ chatBlurred: false }),
  })
}

/** 오늘 출석 —보상은 서버가 지급하고 bootstrap 으로 돌려준다. 획득 연출은 RewardBurstHost 가 justStamped 를 보고 띄운다 */
export async function claimAttendance() {
  try {
    await ensureAccount()
    const identity = useSessionStore.getState().identity
    const ownerId = useSessionStore.getState().data?.user?.id
    const data = await api<Bootstrap>('/attendance/', {})
    if (
      useSessionStore.getState().identity !== identity ||
      useSessionStore.getState().data?.user?.id !== ownerId
    )
      return
    useSessionStore.getState().applyBootstrap(data)
    useUiStore.getState().set({ justStamped: data.attendance.day })
  } catch (error) {
    toast.show(
      error instanceof Error
        ? error.message
        : '출석 보상을 받지 못했어요. 다시 시도해 주세요.'
    )
  }
}
